import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Sertifikat from '@/components/Sertifikat'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/sertifikat/:status',
      name: 'Sertifikat',
      component: Sertifikat
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js